import { components } from '@atlaskit/select';
import React from 'react';
import { UserOption } from './UserOption';
import AsyncExternalOption from './ExternalUserOption';
import AsyncTeamOption from './TeamOption';
import AsyncGroupOption from './GroupOption';
import AsyncEmailOption from './EmailOption';
import { isEmail, isTeam, isUser, isGroup, isExternalUser } from './utils';
import { isValidEmail } from './emailValidation';

var defaultOption = function defaultOption(_ref) {
  var data = _ref.data.data,
      isSelected = _ref.isSelected,
      status = _ref.status;
  return /*#__PURE__*/React.createElement(UserOption, {
    user: data,
    status: status,
    isSelected: isSelected
  });
};

var dataOption = function dataOption(_ref2) {
  var data = _ref2.data.data,
      isSelected = _ref2.isSelected,
      status = _ref2.status,
      selectProps = _ref2.selectProps;

  if (isExternalUser(data)) {
    return /*#__PURE__*/React.createElement(AsyncExternalOption, {
      user: data,
      status: status,
      isSelected: isSelected
    });
  }

  if (isUser(data)) {
    return /*#__PURE__*/React.createElement(UserOption, {
      user: data,
      status: status,
      isSelected: isSelected
    });
  }

  if (isEmail(data)) {
    return /*#__PURE__*/React.createElement(AsyncEmailOption, {
      email: data,
      emailValidity: isValidEmail(data.id),
      isSelected: isSelected,
      label: selectProps.emailLabel
    });
  }

  if (isTeam(data)) {
    return /*#__PURE__*/React.createElement(AsyncTeamOption, {
      team: data,
      isSelected: isSelected
    });
  }

  if (isGroup(data)) {
    return /*#__PURE__*/React.createElement(AsyncGroupOption, {
      group: data,
      isSelected: isSelected
    });
  }

  return null;
};

export var Option = function Option(props) {
  return /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: defaultOption(props)
  }, dataOption(props)));
};